import React, { FC, useEffect, useMemo, useState } from 'react';

import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import {
    CARD_WIDTH,
    DATA_SLIDER_PARAMS_DEFAULT,
    DEFAULT_STATE_MAX_CARDS,
    EMediaWidth,
} from '@r1-frontend/ui-react/components/NukaCarousel/SliderHoc/constants';
import type { TSliderProps } from '@r1-frontend/ui-react/components/NukaCarousel/SliderHoc/types';
import type { IProps } from '@r1-frontend/ui-react/components/NukaCarousel/SliderHoc/types';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

export const SliderHoc: FC<IProps> = ({ children, cardLength, needWrapGap, withoutArrows, slideWidth, cellSpacing }) => {
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isDesktop = useMatchMedia(EMediaWidth.desktop);
    const isTablet = useMatchMedia(EMediaWidth.sLaptop);
    const arrayMedia = [isMobile, isLaptop, isSDesktop, isDesktop];
    const [maxCardsData, setMaxCardsData] = useState(DEFAULT_STATE_MAX_CARDS);

    useEffect(() => {
        if (~arrayMedia.indexOf(true)) {
            setMaxCardsData(currentSliderProps);
        }
    }, [isMobile, isLaptop, isSDesktop, isDesktop]);

    const currentSliderProps = useMemo((): TSliderProps => {
        switch (true) {
            case isMobile:
                return DATA_SLIDER_PARAMS_DEFAULT.mobile;
            case isLaptop:
                return DATA_SLIDER_PARAMS_DEFAULT.laptop;
            case isSDesktop:
                return DATA_SLIDER_PARAMS_DEFAULT.sDesktop;
            case isDesktop:
                return DATA_SLIDER_PARAMS_DEFAULT.desktop;
            default: return DEFAULT_STATE_MAX_CARDS;
        }
    }, [isMobile, isLaptop, isSDesktop, isDesktop]);

    return (
        cardLength > maxCardsData.value
            ? <ST.Container>
                <NukaCarousel
                    slidesToShow={maxCardsData.value}
                    wrapAround
                    withoutArrows={(withoutArrows && isTablet) ?? isMobile}
                    slideWidth={slideWidth ? `${slideWidth}px` : CARD_WIDTH}
                    cellSpacing={cellSpacing || maxCardsData.gap}
                >
                    {children}
                </NukaCarousel>
            </ST.Container>
            : <ST.Wrapper needWrapGap={needWrapGap}>{children}</ST.Wrapper>
    );
};
